import React from 'react'
import './Button.css'

const SecondaryButton = ({ text, onClick, overrideStyles = false, stylesFromParent, id, disabled }) => {
    var cssClass = disabled ? "secondaryButtonDisabled" : (overrideStyles ? stylesFromParent : "secondaryButton")
    return (
        <button
            type='button'
            className={cssClass}
            onClick={onClick}
            id={id}
            disabled={disabled}
        >
            {text}
        </button>
    )
}

export default SecondaryButton